import { render, staticRenderFns } from "./RidersTable.vue?vue&type=template&id=f4dcfa70&"
import script from "./RidersTable.vue?vue&type=script&lang=js&"
export * from "./RidersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports